<template lang="pug">
  .chart-container
    canvas(ref="metricsChart")
</template>

<script>
  import Chart from 'chart.js'

  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      values: {
        type: Array,
        required: true,
      },
      labels: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        chart: null,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              },
            }],
            xAxes: [{
              ticks: {
                // eslint-disable-next-line arrow-body-style
                callback: (value, index) => {
                  return this.labels.length > 15 && index % 2 !== 0 ? '' : value
                },
              },
            }],
          },
        },
      }
    },

    computed: {
      formattedChartData() {
        return {
          labels: this.labels,
          datasets: [{
            label: this.title,
            data: this.values,
            borderColor: '#0D47A1',
            backgroundColor: 'rgba(25, 118, 210, 0.15)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
          }],
        }
      },
    },

    mounted() {
      this.initChart()
    },

    methods: {
      initChart() {
        const ctx = this.$refs.metricsChart.getContext('2d')
        if (this.chart) {
          this.chart.destroy()
        }
        this.chart = new Chart(ctx, {
          type: 'line',
          data: this.formattedChartData,
          options: this.chartOptions,
        })
      },
    },

    watch: {
      chartData: {
        deep: true,
        handler: 'initChart',
      },
      title: 'initChart',
      labels: 'initChart',
    },
  }
</script>

<style>
  .chart-container {
    position: relative;
    height: 240px;
    width: 100%;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// client/masteradmin/components/LineChart/LineChart.vue